import axios from 'axios';
import { useEffect, useState } from 'react';

/** @param {string} url */
export const useData = (url) => {
	const [data, setData] = useState(/** @type {import('../types/feature').FeatureData | null} */ (null));
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(/** @type {unknown} */ (null));

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(url);
				setData(response.data);
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	return { data, loading, error };
};
